import React from "react";
import logo from "../resources/logo.png";

const Logo = () => {
	return <img src={logo} alt="logo" style={{ width: "56px", height: "56px" }} />;
};

export default Logo;
